<template>
    <div>

        <vue-headful title="Training Course Catalog :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                    <router-link :to="`/training-courses/catalogs`">
                        Catalogs
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    <template v-if="!id">New Catalog</template>
                    <template v-else>
                        <template v-if="!loading">Edit {{ catalog.catalog_name }}</template>
                    </template>
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header">Catalog Details</div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div :class="{'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.catalog_name ,'text-muted': !errors.catalog_name}">
                                    Catalog Name: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-md-8">
                                    <input type="text" v-model="catalog.catalog_name" :class="{'form-control': true, 'is-invalid': errors.catalog_name}" placeholder="Enter Catalog Name" />

                                    <span v-if="errors.catalog_name" class="text-danger">
                                        <span v-for="error in errors.catalog_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div :class="{'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.catalog_description ,'text-muted': !errors.catalog_description}">
                                    Description:
                                </div>
                                <div class="col-md-8">
                                    <b-form-textarea v-model="catalog.catalog_description" :class="{'form-control': true, 'is-invalid': errors.catalog_description}" placeholder="Enter a Description for this Catalog"></b-form-textarea>

                                    <span v-if="errors.catalog_description" class="text-danger">
                                        <span v-for="error in errors.catalog_description">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveCatalog()" :disabled="saving">
                <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                <template v-else>Save Training Course Catalog</template>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                catalog: {},
            }
        },

        computed: {

        },

        methods: {
            //Load the Account
            getCatalog(){
                //Send it
                this.$http.get('/training-courses/catalogs/edit' + (this.id ? '/' + this.id : ''))
                    .then(res => {
                        //Set data
                        this.catalog = res.data.catalog;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveCatalog(){
                //Saving Flag
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http.post('/training-courses/catalogs/edit', this.catalog)
                    .then(res => {
                        //Catalog
                        this.$toastr.success('Training Course Catalog Saved');

                        //Send to the View
                        this.$router.push('/training-courses/catalogs/view/' + res.data.id);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Catalog the user
                            this.$toastr.error(error.response.data, 'Failed to Save Catalog');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            }
        },

        mounted(){
            //Get it
            this.getCatalog();
        }
    }
</script>
